import { resetAnalytics } from '@zet/analytics'
import useAuthStore from '@zet/feature-user/store/authStore'
import { zetApi } from '@zet/network'
import { queryClient } from '@zet/utils/queryClient'
import storageUtil from '@zet/utils/storage'

export const logout = async () => {
  storageUtil.mmkvStorage.clearAll()
  storageUtil.deleteObject('REACT_QUERY_OFFLINE_CACHE')
  useAuthStore.setState({ isAuthenticated: false })
  useAuthStore.setState({ authToken: '' })
  storageUtil.deleteObject('token')
  resetAnalytics()
  queryClient?.clear()
  delete zetApi.defaults.headers.common['Authorization']
}
